// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__tMaEM","contentCtr":"Modal_contentCtr__nbj0Y"};